import axios from 'axios';
import { getApiBaseUrl } from '../apiBaseUrlFinder';

export const authService = {
  // Sign in user
  signIn: async (workEmail, password) => {
    const response = await axios.post(`${getApiBaseUrl()}/signin`, {
      work_email: workEmail,
      password: password,
    });
    
    return response.data;
  },

  // Sign up user
  signUp: async (workEmail, personalEmail, password) => {
    const utm_source = localStorage.getItem("utm_source") || "direct";
    const response = await axios.post(`${getApiBaseUrl()}/signup`, {
      work_email: workEmail,
      personal_email: personalEmail,
      password: password,
      utm_source,
    });
    return response.data;
  },

  // Store authentication data
  storeAuthData: (token, userId, workEmail) => {
    localStorage.setItem('token', token);
    const expiryTime = Date.now() + 60 * 60 * 1000; // 1 hour
    localStorage.setItem('tokenExpiry', expiryTime);
    
    return {
      token,
      user_id: userId,
      work_email: workEmail,
    };
  },

  // Clear authentication data
  clearAuthData: () => {
    localStorage.removeItem('token');
    localStorage.removeItem('tokenExpiry');
  },

  // Check if user is authenticated
  isTokenValid: () => {
    const token = localStorage.getItem('token');
    const expiry = localStorage.getItem('tokenExpiry');
    
    if (!token || !expiry) return false;
    
    return Date.now() < parseInt(expiry);
  }
}; 